import { useApi, microsoftAuthApiRef, configApiRef } from '@backstage/core-plugin-api';
import { useEffect, useState } from 'react';

const TOKEN_REFRESH_INTERVAL_MS = 5 * 60 * 1000; // Refresh every 5 minutes
const RETRY_INTERVAL_MS = 30 * 1000; // Retry after 30 seconds on error

export function useEntraUserToken() {
  const microsoftAuth = useApi(microsoftAuthApiRef);
  const configApi = useApi(configApiRef);
  const scope = configApi.getString('varia.entraScope');
  const [token, setToken] = useState<string | undefined>(undefined);
  const [error, setError] = useState<Error | undefined>(undefined);

  useEffect(() => {
    let cancelled = false;

    const fetchToken = async () => {
      try {
        // getAccessToken silently refreshes if the token is near expiry.
        // optional: true prevents a login popup if the session has expired
        // instantPopup: false ensures we don't trigger a new login flow
        const accessToken = await microsoftAuth.getAccessToken(scope, {
          optional: true,
          instantPopup: false,
        });

        if (!cancelled) {
          setToken(accessToken);
          setError(undefined);
        }
      } catch (e) {
        if (!cancelled) {
          setError(e as Error);
        }
      }
    };

    fetchToken();
    const intervalId = setInterval(
      fetchToken,
      error ? RETRY_INTERVAL_MS : TOKEN_REFRESH_INTERVAL_MS,
    );

    return () => {
      cancelled = true;
      clearInterval(intervalId);
    };
  }, [microsoftAuth, scope, error]);

  return { token, error };
}
